import { useState } from 'react';
import axios from 'axios';
import { getWordpressVars } from '@lib/wordpressVars';

const useFileDownloader = () => {
    const { root, nonce } = getWordpressVars();
    
    const [error, setError] = useState<any>(null);

    const [success, setSuccess] = useState<any>(null);

    const downloadFile = async (apiEndpoint, postData, fileName) => {

        setSuccess(false);

        try {
            const response = await axios.post(`${root}${apiEndpoint}`, postData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce,
                },
                responseType: 'blob',
                method: 'POST',
            });

            if(response.status === 200) {
                setSuccess(true);
            }
            
            const blob = new Blob([response.data], { type: 'text/csv' });

            const link = document.createElement('a');
            
            link.href = window.URL.createObjectURL(blob);
            
            link.download = fileName || 'download.csv';
            
            document.body.appendChild(link);
            
            link.click();
            
            document.body.removeChild(link);
            
        } catch (error: any) {
            setError('Error downloading CSV: ' + error.message);
        }
    };

    return { downloadFile, error, success };
};

export default useFileDownloader;
